import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import axios from "axios";

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI)

import AOS from "aos";
import "../node_modules/aos/dist/aos.css";
AOS.init();
Vue.use(AOS);

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

import Video from "video.js"
import "video.js/dist/video-js.css"
Vue.prototype.$video = Video

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL// api 即上面 vue.config.js 中配置的地址

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
